import { faTrophy } from '@fortawesome/pro-regular-svg-icons';
import React, { Dispatch, SetStateAction } from 'react';
import { DomainTypeGq } from '../../../../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';

export interface AddRankDataButtonProps {
  project: ProjectGq;
  setOpenAddDomainDialog?: Dispatch<SetStateAction<DomainTypeGq>>;
  setOpenRanksDialog?: Dispatch<SetStateAction<boolean>>;
  openGetRanksDialog?: boolean;
  selectionActive?: boolean;
}

export const AddRankDataButton: React.FC<AddRankDataButtonProps> = ({
  setOpenAddDomainDialog,
  setOpenRanksDialog,
  project,
  openGetRanksDialog,
  selectionActive,
}) => {
  const handleAddRankData = () => {
    if (!project.domains?.some((d) => d.type === DomainTypeGq.PROJECT)) {
      setOpenAddDomainDialog(DomainTypeGq.PROJECT);
      setOpenRanksDialog(true);
    } else {
      setOpenRanksDialog(true);
    }
  };

  return (
    <DataTableToolbarButton
      label="Add rank data"
      toggle={openGetRanksDialog}
      tooltip="Add or update rank data"
      iconProp={faTrophy}
      onClick={handleAddRankData}
      effect={selectionActive ? 'primary' : undefined}
      effectAnimate={false}
    />
  );
};

export default AddRankDataButton;
